import React from 'react';
import Rate, {AndroidMarket} from 'react-native-rate';
import {
  ButtonsContainer,
  CloseIcon,
  CloseIconButton,
  Container,
  Icon,
  LikeButtonContainer,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalText,
  ModalTitle,
} from './styles';
import Modal from 'react-native-modal';
import {useTheme} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useTutorial } from '../../../context/TutorialProvider';

interface IPromoModal {
  isVisible: boolean;
  onDismiss: () => void;
}

export function RateInStore({isVisible, onDismiss}: IPromoModal) {
  const {isActive} = useTutorial();
  const theme = useTheme();
  const options = {
    AppleAppID: '1613535824',
    GooglePackageName: 'com.barataoapp',
    preferredAndroidMarket: AndroidMarket.Google,
    preferInApp: true,
    openAppStoreIfInAppFails: true,
  };

  function handleRateModal() {
    Rate.rate(options, (success, errorMessage) => {
      if (success) {
      }
      if (errorMessage) {
      }
    });
    onDismiss();
    updateLastRatingDisplayDate();
  }

  const updateLastRatingDisplayDate = async () => {
    try {
      const now = new Date();
      await AsyncStorage.setItem('lastRatingDisplayDate_', now.toISOString());
    } catch (error) {
      console.error(
        'Erro ao atualizar a data da última exibição do modal de avaliação',
        error,
      );
    }
  };

  return (
    <Container>
      <Modal
        isVisible={isVisible && !isActive}
        onDismiss={onDismiss}
        onBackdropPress={onDismiss}
        onBackButtonPress={onDismiss}>
        <ModalContainer>
          <ModalContent>
            <CloseIconButton activeOpacity={1} onPress={onDismiss} testID="closeRateInStore">
              <CloseIcon name="x" />
            </CloseIconButton>

            <ModalBody>
              <ModalTitle>Ajude-nos a melhorar!</ModalTitle>
              <ModalText>
                Sua opinião é importante para nós. Gostaria de avaliar o
                aplicativo?
              </ModalText>
            </ModalBody>
            <ModalFooter>
              <ButtonsContainer>
                <LikeButtonContainer
                  style={{marginRight: RFValue(14)}}
                  activeOpacity={0.7}
                  onPress={() => handleRateModal()}>
                  <Icon name="thumbs-up" />
                </LikeButtonContainer>
                <LikeButtonContainer
                  activeOpacity={0.7}
                  onPress={() => onDismiss()}
                  style={{backgroundColor: theme.colors.red}}>
                  <Icon name="thumbs-down" />
                </LikeButtonContainer>
              </ButtonsContainer>
            </ModalFooter>
          </ModalContent>
        </ModalContainer>
      </Modal>
    </Container>
  );
}
